import React from "react"

export default function EmailValidation() {
  return (
    <div style={styles.body}>
      <div style={styles.wrapperAlert}>
        <div style={styles.topHalf}>
          <p>
            <svg viewBox="0 0 512 512" width="100" title="check-circle">
              <path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z" fill="white" />
            </svg>
          </p>
          <h1 style={styles.h1}>Obrigado pela validação do email.</h1>
          <ul style={styles.bgBubbles}>
            {[...Array(10)].map((_, i) => (
              <li key={i} style={{ ...styles.bubble, ...bubbleStyles[i] }} />
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

const styles = {
  body: {
    height: "100vh",
    display: "flex",
    fontSize: 14,
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "'Khand', sans-serif",
  },
  wrapperAlert: {
    width: 500,
    overflow: "hidden",
    borderRadius: 12,
    border: "thin solid #ddd",
    position: "relative",
  },
  topHalf: {
    width: "100%",
    color: "white",
    overflow: "hidden",
    minHeight: 250,
    position: "relative",
    padding: "40px 0",
    background: "linear-gradient(45deg, #019871, #a0ebcf)",
  },
  h1: {
    fontSize: "2.25rem",
    display: "block",
    fontWeight: 500,
    letterSpacing: "0.15rem",
    textShadow: "0 2px rgba(128, 128, 128, 0.6)",
  },
  bgBubbles: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    margin: 0,
    padding: 0,
    listStyle: "none",
    zIndex: 1,
  },
  bubble: {
    position: "absolute",
    display: "block",
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    bottom: -160,
    animationName: "square",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear",
    animationDuration: "20s",
  },
}

const bubbleStyles = [
  { left: "10%", width: 40, height: 40 },
  { left: "20%", width: 80, height: 80, animationDelay: "2s", animationDuration: "17s" },
  { left: "25%", width: 40, height: 40, animationDelay: "4s" },
  { left: "40%", width: 60, height: 60, animationDuration: "22s", backgroundColor: "rgba(255,255,255,0.3)" },
  { left: "70%", width: 40, height: 40 },
  { left: "80%", width: 120, height: 120, animationDelay: "3s", backgroundColor: "rgba(255,255,255,0.2)" },
  { left: "32%", width: 160, height: 160, animationDelay: "7s" },
  { left: "55%", width: 20, height: 20, animationDelay: "15s", animationDuration: "40s" },
  { left: "25%", width: 10, height: 10, animationDelay: "2s", animationDuration: "40s", backgroundColor: "rgba(255,255,255,0.3)" },
  { left: "90%", width: 160, height: 160, animationDelay: "11s" },
]

const styleSheet = document.createElement("style")
styleSheet.type = "text/css"
styleSheet.innerText = `
@keyframes square {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-500px) rotate(600deg);
  }
}
@import url("https://fonts.googleapis.com/css2?family=Khand:wght@500&display=swap");
`
document.head.appendChild(styleSheet)
